module.exports = __webpack_public_path__ + "img/arrow-right-bold.0ed01d49.svg";